import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@nrwl/common-lib';

@Injectable({
  providedIn: 'root'
})
export class UserAdministrationService {
  getAllUsersPath = '/ims/v2/users?filter=local';
  getUserPath = '/ims/v2/users/';
  getAllGroupsPath = '/ims/v2/groups/';
  getAllRolesPath = '/ims/v2/roles/';
  getAllLicensePath = '/licensing/licenses';
  getMePath = '/ims/v2/users/me';

  disableUserPath = '/ims/v2/users/';
  enableUserPath = '/ims/v2/users/';

  constructor(private readonly apiService: ApiService) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getUsers$(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(this.getAllUsersPath, {});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getUser$(userId:string): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(this.getUserPath + userId, {});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMe$(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(this.getMePath, {});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getGroups$(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(this.getAllGroupsPath, {});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getRoles$(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(this.getAllRolesPath, {});
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  retrieveWidgetDataQuery$(url: any, data: any): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>('/' + url, data);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  disableUser$(id: string): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>(this.disableUserPath + id + '/' + 'disable');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  enableUser$(id: string): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>(this.enableUserPath + id + '/' + 'enable');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAllGroups$(): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>('/ims/v2/groups', {});
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getBaseLicence$(): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(this.getAllLicensePath, {});
  }
}
